import {useMutation} from '@tanstack/react-query';
import {DeleteBatchRefundProcedureParams} from 'domain/usecases/private/refund/request/delete-batch-procedure';
import {deleteBatchProcedure} from '../services/deleteBatchProcedure';

export const useDeleteBatchProcedureMutation = () =>
	useMutation({
		mutationFn: (params: DeleteBatchRefundProcedureParams) => deleteBatchProcedure(params),
		retry: 1,
	});
